export enum ReportType {
    Incident = 'incident',
    Report = 'report',
    Complaint = 'complaint',
    Feedback = 'feedback',
    NonConformity = 'nonconformity',
};
